import isAvailableVariantUtil from 'modules/variant/utils/is-available'
import getVariantsProductVariantUtil from 'modules/product-variant/utils/get-variants'
import isAvailableRawProductVariantUtil from 'modules/product-variant/utils/is-available-raw'

/**
 * @param productVariant
 * @param shouldShowVariants
 * @param isGiftCard
 * @param shouldShowQuickShades
 * @returns {boolean}
 */
const isOutOfStockProductVariantUtil = ({
  productVariant,
  shouldShowVariants,
  isGiftCard,
  shouldShowQuickShades
}) => {
  if (isGiftCard) {
    return false
  }

  if (
    shouldShowQuickShades &&
    !isAvailableRawProductVariantUtil(productVariant)
  ) {
    return true
  }

  const variants = getVariantsProductVariantUtil(productVariant)
  const isAllVariantsOutOfStock = variants?.every(variant => !isAvailableVariantUtil(variant)) ?? false
  const isCurrentVariantOutOfStock = !isAvailableVariantUtil(productVariant)

  if (
    shouldShowVariants &&
    isAllVariantsOutOfStock &&
    isCurrentVariantOutOfStock
  ) {
    return true
  }

  if (
    isCurrentVariantOutOfStock &&
    !shouldShowVariants
  ) {
    return true
  }

  return false
}

export default isOutOfStockProductVariantUtil
